import { render, staticRenderFns } from "./additionalMenu.vue?vue&type=template&id=309dca62&scoped=true&"
import script from "./additionalMenu.vue?vue&type=script&lang=js&"
export * from "./additionalMenu.vue?vue&type=script&lang=js&"
import style0 from "./additionalMenu.vue?vue&type=style&index=0&id=309dca62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "309dca62",
  null
  
)

export default component.exports